import { faCircleNotch } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

let statusSafra = []
statusSafra.push({ id: "16, 17", name: "Em produção" })
statusSafra.push({
  id: "1, 2, 3, 13, 14, 15, 18, 25, 21",
  name: "Em fluxo de transporte",
})
statusSafra.push({ id: 5, name: "Saiu pra entrega" })
statusSafra.push({ id: "6, 19, 22, 28", name: "Entregue" })
statusSafra.push({ id: 8, name: "Aguardando Retirada - Correios" })
statusSafra.push({ id: 10, name: "Em devolução" })
statusSafra.push({ id: "7, 12", name: "Em Custódia" })
statusSafra.push({ id: 4, name: "Extraviado" })
statusSafra.push({ id: 11, name: "Incinerado" })
statusSafra.push({ id: "23, 24", name: "Fora do fluxo padrão" })
statusSafra.push({ id: "9, 20, 26, 27", name: "Fluxo cancelado" })
export const statusSafraOptions = statusSafra.map(status => ({
  value: status.id,
  label: status.name,
}))

export const exportLabels = {
  arCourrier: "AR Transportadora",
  arMestre: "AR Mestre",
  bairro: "Bairro",
  cep: "CEP",
  cidade: "Cidade",
  cnpjCliente: "CNPJ do Cliente",
  codPlastico: "Código Plástico",
  codPlasticoV1: "Código Plástico V1",
  complemento: "Complemento",
  contrato: "Nº do Contrato",
  cpfColaborador: "CPF do Colaborador",
  dataCadastroFvs: "Data de Cadastro do FVS",
  dataEntrega: "Data de Entrega",
  dataMovimento: "Data do Movimento",
  dataPedidoFVS: "Data do Pedido FVS",
  dataExpedição: "Data da Expedição",
  dataProcessamentoPedidoFvs: "Data de Processamento do Pedido FVS",
  destinatario: "Destinatário",
  emailColaborador: "Email do Colaborador",
  email_1: "Email nº 1",
  email_2: "Email nº 2",
  email_3: "Email nº 3",
  embossadora: "Fábrica",
  empresa: "Empresa",
  expectativaEntrega: "Expectativa de Entrega",
  filialEntrega: "Filial de Entrega",
  idLote: "Lote",
  interlocutor_1: "Interlocutor nº 1",
  interlocutor_2: "Interlocutor nº 2",
  interlocutor_3: "Interlocutor nº 3",
  matriculaColaborador: "Matricula do Colaborador",
  modeloEntrega: "Modelo de Entrega",
  nomeColaborador: "Nome do Colaborador",
  numero: "Número",
  pedidoFvs: "Pedido FVS",
  pedidoWeb: "Pedido Web",
  premium: "Premium",
  qtdCartoes: "Qtde. de Cartões",
  rua: "Rua",
  Status: "Status",
  telColaborador: "Telefone do Colaborador",
  telEmpresa: "Telefone da Empresa",
  telInterlocutor_1: "Telefone do Interlocutor nº 1",
  telInterlocutor_2: "Telefone do Interlocutor nº 2",
  telInterlocutor_3: "Telefone do Interlocutor nº 3",
  tentativasEntrega: "Tentativas de Entrega",
  tipoEmissao: "Tipo de Emissão",
  transportadora: "Transportadora",
  uf: "UF",
}

export const badgesClass = {
  1: "bg-success",
  2: "bg-info",
  3: "bg-info",
  4: "bg-danger",
  5: "bg-success",
  6: "bg-success",
  7: "bg-warning",
  8: "bg-info",
  9: "bg-danger",
  10: "bg-warning",
  11: "bg-danger",
  12: "bg-danger",
  13: "bg-info",
  14: "bg-info",
  15: "bg-danger",
  16: "bg-info",
  17: "bg-info",
  18: "bg-info",
  19: "bg-info",
  20: "bg-danger",
  21: "bg-info",
  22: "bg-info",
  23: "bg-warning",
  24: "bg-danger",
  25: "bg-info",
  26: "bg-danger",
}

export const courierClass = {
  1: "bg-warning",
  2: "bg-secondary",
  3: "bg-success",
  4: "bg-info",
}

export const getIcon = statusId => {
  const icons = {
    2: "bx-paper-plane",
    3: "bx-transfer",
    5: "bxs-truck",
    6: "bx-check-circle",
    7: "bx-undo",
    10: "bx-edit",
    12: "bxs-hourglass",
    15: "bx-x-circle",
    25: "bxs-factory",
  }
  return icons[Number(statusId)] || "bx-transfer"
}

export const getLocalName = (
  rawInfo,
  status,
  shippingLocal,
  order,
  interlogAr,
  flashAr,
  mobiAr
) => {
  try {
    if (shippingLocal == "null - null") {
      shippingLocal = " "
    }
    const _rawInfo = JSON.parse(rawInfo)

    const code = `${_rawInfo.tipo}_${_rawInfo.status}`
    if (
      _rawInfo.endereco &&
      [
        "LDI_00",
        "LDI_01",
        "LDI_02",
        "LDI_03",
        "LDI_14",
        "BDE_24",
        "BDR_24",
        "BDI_24",
        "BDR_54",
        "BDI_54",
        "BDE_54",
        "BDE_55",
        "BDR_55",
        "BDI_55",
        "BDE_58",
        "BDI_58",
        "BDR_58",
        "BDE_59",
        "BDI_59",
        "BDR_59",
      ].indexOf(code) >= 0
    ) {
      const endereco = _rawInfo.endereco[0]

      return `${endereco.logradouro[0]} - ${endereco.numero[0]}, ${endereco.bairro[0]} - ${endereco.localidade[0]}/${endereco.uf[0]}`
    }
  } catch (error) {}

  try {
    const _rawInfo = JSON.parse(rawInfo)
    const transport = order.shippingCompany.name
    if (
      status.name == "Encaminhado para os Correios" &&
      transport == "InterLog"
    ) {
      return _rawInfo.codentregacorreio
    }
    if (status.name == "Encaminhado para os Correios" && transport == "Flash") {
      const arCorreios = _rawInfo.numEncTer ? _rawInfo.numEncTer : "Sem numero"
      return arCorreios
    }

    if (status.name == "Entregue") {
      if (order.digitalAr && transport !== "Flash") {
        if (order.digitalAr == "Sem link") {
          if (transport == "Interlog" && interlogAr?.loading) {
            return (
              <FontAwesomeIcon
                icon={faCircleNotch}
                spin
                size="1x"
                color="#000"
              />
            )
          }

          if (interlogAr.base64) {
            return (
              <a
                style={{ display: "table-cell", color: "green" }}
                href={interlogAr.base64}
                target="_blank"
              >
                Ar Digital
              </a>
            )
          }
          return interlogAr.text
        }
        return (
          <a
            style={{ display: "table-cell", color: "green" }}
            href={order.digitalAr}
            target="_blank"
          >
            Ar Digital
          </a>
        )
      }

      if (transport == "Flash" && flashAr?.loading) {
        return (
          <FontAwesomeIcon icon={faCircleNotch} spin size="1x" color="#000" />
        )
      }

      if (transport == "Mobi" && mobiAr?.loading) {
        return (
          <FontAwesomeIcon icon={faCircleNotch} spin size="1x" color="#000" />
        )
      }

      if (transport == "Flash" && !flashAr?.loading) {
        if (flashAr.status) {
          const openInNewTab = url => {
            let win = window.open()
            win.document.write(
              '<iframe src="' +
                url +
                '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>'
            )
          }
          return (
            <a
              style={{ display: "table-cell", color: "green" }}
              onClick={() => {
                openInNewTab(`data:image/jpeg;base64,${flashAr.base64}`)
              }}
            >
              Ar Digital
            </a>
          )
        } else {
          return flashAr.text
        }
      }

      if (transport == "Mobi" && !mobiAr?.loading) {
        if (mobiAr.status) {
          const openInNewTab = url => {
            let win = window.open()
            win.document.write(
              '<iframe src="' +
                url +
                '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>'
            )
          }
          return (
            <a
              style={{ display: "table-cell", color: "green" }}
              onClick={() => {
                openInNewTab(mobiAr.base64)
              }}
            >
              Ar Digital
            </a>
          )
        } else {
          return mobiAr.text
        }
      }
    }
  } catch (error) {}
  return shippingLocal || status?.name
}
